import React from 'react';
import { BarChart, Bar, LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, AreaChart, Area } from 'recharts';
import { Download, Users, Home, AlertTriangle } from 'lucide-react';
const userGrowthData = [{
  name: 'Jan',
  buyers: 400,
  sellers: 240
}, {
  name: 'Feb',
  buyers: 300,
  sellers: 139
}, {
  name: 'Mar',
  buyers: 200,
  sellers: 980
}, {
  name: 'Apr',
  buyers: 278,
  sellers: 390
}, {
  name: 'May',
  buyers: 189,
  sellers: 480
}, {
  name: 'Jun',
  buyers: 239,
  sellers: 380
}];
const propertyDemandData = [{
  name: 'Maitama',
  demand: 85
}, {
  name: 'Asokoro',
  demand: 70
}, {
  name: 'Wuse 2',
  demand: 90
}, {
  name: 'Gwarinpa',
  demand: 65
}, {
  name: 'Jabi',
  demand: 55
}];
export const ReportsAnalytics = () => {
  return <div className="space-y-6 animate-in fade-in" data-id="element-856">
      <div className="flex justify-between items-center" data-id="element-857">
        <div data-id="element-858">
          <h1 className="text-2xl font-serif font-bold text-slate-900 dark:text-white mb-1" data-id="element-859">
            Reports & Analytics
          </h1>
          <p className="text-slate-500 dark:text-slate-400" data-id="element-860">
            Advanced platform insights and data exports.
          </p>
        </div>
        <button className="px-4 py-2 bg-secondary hover:bg-secondary-dark text-primary-900 font-bold rounded-lg flex items-center gap-2 transition-colors" data-id="element-861">
          <Download size={18} data-id="element-862" /> Export Report
        </button>
      </div>

      <div className="grid lg:grid-cols-2 gap-6" data-id="element-863">
        {/* User Growth */}
        <div className="bg-white dark:bg-[#1e293b] rounded-2xl border border-slate-200 dark:border-slate-700 p-6" data-id="element-864">
          <div className="flex items-center gap-3 mb-6" data-id="element-865">
            <div className="p-2 bg-blue-100 dark:bg-blue-400/10 rounded-lg text-blue-600 dark:text-blue-400" data-id="element-866">
              <Users size={20} data-id="element-867" />
            </div>
            <h2 className="text-lg font-bold text-slate-900 dark:text-white" data-id="element-868">
              User Growth
            </h2>
          </div>
          <div className="h-64" data-id="element-869">
            <ResponsiveContainer width="100%" height="100%" data-id="element-870">
              <AreaChart data={userGrowthData} data-id="element-871">
                <CartesianGrid strokeDasharray="3 3" vertical={false} stroke="currentColor" className="text-slate-200 dark:text-slate-700" data-id="element-872" />
                <XAxis dataKey="name" axisLine={false} tickLine={false} tick={{
                fill: '#94a3b8',
                fontSize: 12
              }} data-id="element-873" />
                <YAxis axisLine={false} tickLine={false} tick={{
                fill: '#94a3b8',
                fontSize: 12
              }} data-id="element-874" />
                <Tooltip contentStyle={{
                backgroundColor: 'var(--tw-bg-opacity, #fff)',
                borderColor: 'var(--tw-border-opacity, #e2e8f0)',
                color: 'var(--tw-text-opacity, #0f172a)'
              }} itemStyle={{
                color: 'var(--tw-text-opacity, #0f172a)'
              }} data-id="element-875" />
                <Area type="monotone" dataKey="buyers" stackId="1" stroke="#3b82f6" fill="#3b82f6" fillOpacity={0.2} data-id="element-876" />
                <Area type="monotone" dataKey="sellers" stackId="1" stroke="#C8A24A" fill="#C8A24A" fillOpacity={0.2} data-id="element-877" />
              </AreaChart>
            </ResponsiveContainer>
          </div>
        </div>

        {/* Property Demand */}
        <div className="bg-white dark:bg-[#1e293b] rounded-2xl border border-slate-200 dark:border-slate-700 p-6" data-id="element-878">
          <div className="flex items-center gap-3 mb-6" data-id="element-879">
            <div className="p-2 bg-emerald-100 dark:bg-emerald-400/10 rounded-lg text-emerald-600 dark:text-emerald-400" data-id="element-880">
              <Home size={20} data-id="element-881" />
            </div>
            <h2 className="text-lg font-bold text-slate-900 dark:text-white" data-id="element-882">
              District Demand (Searches)
            </h2>
          </div>
          <div className="h-64" data-id="element-883">
            <ResponsiveContainer width="100%" height="100%" data-id="element-884">
              <BarChart data={propertyDemandData} layout="vertical" margin={{
              left: 20
            }} data-id="element-885">
                <CartesianGrid strokeDasharray="3 3" horizontal={false} stroke="currentColor" className="text-slate-200 dark:text-slate-700" data-id="element-886" />
                <XAxis type="number" axisLine={false} tickLine={false} tick={{
                fill: '#94a3b8',
                fontSize: 12
              }} data-id="element-887" />
                <YAxis dataKey="name" type="category" axisLine={false} tickLine={false} tick={{
                fill: '#94a3b8',
                fontSize: 12
              }} data-id="element-888" />
                <Tooltip cursor={{
                fill: 'var(--tw-bg-opacity, #f1f5f9)'
              }} contentStyle={{
                backgroundColor: 'var(--tw-bg-opacity, #fff)',
                borderColor: 'var(--tw-border-opacity, #e2e8f0)',
                color: 'var(--tw-text-opacity, #0f172a)'
              }} itemStyle={{
                color: 'var(--tw-text-opacity, #0f172a)'
              }} data-id="element-889" />
                <Bar dataKey="demand" fill="#10b981" radius={[0, 4, 4, 0]} barSize={20} data-id="element-890" />
              </BarChart>
            </ResponsiveContainer>
          </div>
        </div>

        {/* Fraud Analytics */}
        <div className="bg-white dark:bg-[#1e293b] rounded-2xl border border-slate-200 dark:border-slate-700 p-6 lg:col-span-2" data-id="element-891">
          <div className="flex items-center gap-3 mb-6" data-id="element-892">
            <div className="p-2 bg-red-100 dark:bg-red-400/10 rounded-lg text-red-600 dark:text-red-400" data-id="element-893">
              <AlertTriangle size={20} data-id="element-894" />
            </div>
            <h2 className="text-lg font-bold text-slate-900 dark:text-white" data-id="element-895">
              Fraud Detection Trends
            </h2>
          </div>
          <div className="h-64" data-id="element-896">
            <ResponsiveContainer width="100%" height="100%" data-id="element-897">
              <LineChart data={userGrowthData} data-id="element-898">
                <CartesianGrid strokeDasharray="3 3" vertical={false} stroke="currentColor" className="text-slate-200 dark:text-slate-700" data-id="element-899" />
                <XAxis dataKey="name" axisLine={false} tickLine={false} tick={{
                fill: '#94a3b8',
                fontSize: 12
              }} data-id="element-900" />
                <YAxis axisLine={false} tickLine={false} tick={{
                fill: '#94a3b8',
                fontSize: 12
              }} data-id="element-901" />
                <Tooltip contentStyle={{
                backgroundColor: 'var(--tw-bg-opacity, #fff)',
                borderColor: 'var(--tw-border-opacity, #e2e8f0)',
                color: 'var(--tw-text-opacity, #0f172a)'
              }} itemStyle={{
                color: 'var(--tw-text-opacity, #0f172a)'
              }} data-id="element-902" />
                <Line type="monotone" dataKey="sellers" name="Flags Raised" stroke="#ef4444" strokeWidth={3} dot={{
                r: 4,
                fill: '#ef4444',
                strokeWidth: 2,
                stroke: 'currentColor'
              }} className="text-white dark:text-[#1e293b]" data-id="element-903" />
              </LineChart>
            </ResponsiveContainer>
          </div>
        </div>
      </div>
    </div>;
};